let enable_button = ($button, buttonHtml) => {
    window.Smart.console.log('enable_button', $button, buttonHtml);

    if ($button === null) {
        return;
    }

    $button.removeAttr('disabled');
    $button.removeClass('disabled');

    // Use regular expression to remove the div
    buttonHtml = buttonHtml.replace(/<div class="waves-ripple".*?<\/div>/g, '');

    $button.html(buttonHtml);
}

export default enable_button;
